var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "m-5" }, [
    _c("div", { staticClass: "row blockAbove m-3" }),
    _vm._v(" "),
    _c("div", { staticClass: "row ontologies-page description m-3" }, [
      _vm._v(
        "\n      Sharing and exploiting knowledge sources is vital to the domain of agriculture, food and living environment or Quality of Life in general.\n      Public information should be available freely. In particular if this information is formalized along the lines of the Semantic Web, or as Linked Data,\n      direct electronic access can have a strong impact on innovation in this area.\n      The objective of foodvoc.org is to publish vocabularies and associated web services relevant to this domain.\n      Here, you can browse our vocabularies and directly interface with them. The vocabularies are the result of publicly financed projects.\n      They are mostly based on multiple sources.\n      Presently foodvoc.org provides vocabularies on the general domain of physical units and quantities, food additives, drinks and dairy products.\n      Feedback on content and structure of the vocabularies is most welcome.\n  "
      )
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "ul",
        { staticClass: "ontology-list" },
        _vm._l(_vm.ontologies, function(ontology, key) {
          return _c("li", { key: key, staticClass: "row my-4" }, [
            _c(
              "div",
              { staticClass: "col-10" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "ontology-title",
                    attrs: {
                      to: {
                        name: "ontology",
                        params: { ontology: ontology.id }
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(ontology.name))]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-1" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn btn-outline-success",
                    attrs: {
                      href: _vm.downloadUrl + ontology.id + ".ttl",
                      size: "sm",
                      download: ""
                    }
                  },
                  [_vm._v("Download")]
                )
              ],
              1
            )
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fc131acc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc131acc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RootPane.vue
// module id = null
// module chunks = 